import { useEffect, useState } from 'react';
import api from '../api';
import { useAuthContext } from './UseAuthContext';

/**
 * Resolves admin role from /get-user (status === 'admin').
 * Login payload may also include status after backend update.
 */
export function useIsAdmin() {
  const { user } = useAuthContext();
  const [isAdmin, setIsAdmin] = useState(user?.status === 'admin');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    if (user.status === 'admin') {
      setIsAdmin(true);
      setLoading(false);
      return;
    }

    let cancelled = false;
    api.get('/get-user')
      .then((res) => {
        if (!cancelled) setIsAdmin(res.data?.status === 'admin');
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { isAdmin, loading };
}
